import { checkAuthorities, checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import { StateRoot } from "@/store/state";
import { getLoginData } from "@/lib/authHelper";

export function authoritiesRouteGuard(requiredAuthorities: StateRoot["authorities"]): boolean {
  const data = getLoginData();
  return checkAuthorities(data?.authorities ?? [], requiredAuthorities);
}

export function roleRouteGuard(requiredRoles: string | string[]): boolean {
  const data = getLoginData();
  if (!Array.isArray(requiredRoles)) {
    return checkRole(data?.user.role ?? "", requiredRoles);
  }

  return requiredRoles.includes(data?.user.role || "");
}
